module.exports = __webpack_public_path__ + "img/img-map-style-hybrid.e1090c58.png";